import { Table } from "@/components/ui/Table";
import { useEffect, useState } from "react";
import { contactsApi } from "@/api/contacts.ts";
import {Link, useParams} from "react-router-dom";
import { TableItem } from "@/pages/logs/styles.ts";
import { formatDate } from "@/utils/formatDate.ts";
import { Title } from "@/components/ui/Title.ts";
import { Breadcrumbs } from "@/components/ui/Breadcrumbs.ts";
import { IoChevronForward } from "react-icons/io5";
import { AssistantName } from "@/pages/styles/AssistantsPage.styles.ts";
import { fetchAssistant } from "@/store/assistantSlice.ts";
import { useAppDispatch } from "@/hooks/redux.ts";
import { useSelector } from "react-redux";
import { RootState } from "@/store";
import { setCurrentUser } from "@/store/logsSlice.ts";

const TableHeaders = [
    { text: 'Имя', value: 'name' },
    { text: 'Сообщений', value: 'messages' },
    { text: 'Последнее сообщение', value: 'lastMessageDate' },
]

interface ITableItem {
    id: number;
    name: string;
    messages: number;
    newMessages: number;
    lastMessageDate: string;
}

export const LogsInAssistantPage = () => {
    const [data, setData] = useState<ITableItem[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { id } = useParams();
    const dispatch = useAppDispatch();
    const { assistant } = useSelector((state: RootState) => state.assistant);

    const setDataInStore = (item: any) => {
        dispatch(setCurrentUser(item))
    }

    useEffect(() => {
        if(id) {
            dispatch(fetchAssistant(Number(id)))
        }
    }, [id]);

    const getAssistantLogsData = async () => {
        if(id) {
            setIsLoading(true);
            const { data } = await contactsApi.getAll(id).finally(() => {
                setIsLoading(false);
            });
            if(data) {
                const mappedData = data.map(i => ({
                    id: i.ID,
                    name: i.name,
                    messages: i.sessions_count,
                    newMessages: i.new_sessions_count,
                    lastMessageDate: i.sessions_count ? formatDate(i.last_message_date) : 'Нет новых сообщений'
                }))
                setData(mappedData)
            }
        }
    }
    useEffect(() => {
        getAssistantLogsData()
    }, []);
    return (
        <div>
            <div>
                <Title style={{ marginBottom: '24px' }}>Логи в “{assistant?.Name}”</Title>
                <Breadcrumbs>
                    <Link to="/dashboard/logs">Логи</Link>
                    <IoChevronForward size={14} color="#000000"/>
                    <span>{assistant?.Name}</span>
                </Breadcrumbs>
            </div>
            <Table loading={isLoading} headers={TableHeaders} data={data} tableKey={'id'}>
                {({ value, column, item}) => {
                    if(column === 'name') {
                        return (
                            <TableItem>
                                <AssistantName
                                    onClick={() => setDataInStore(item)}
                                    to= {`/dashboard/logs/${id}/assistant/${item.id}`}
                                >
                                    {value}
                                </AssistantName>
                            </TableItem>
                        )
                    }
                    if(column === 'messages') {
                        return (
                            <TableItem>
                                <div style={{ display: 'flex' }}>
                                    {value}
                                    {item.newMessages > 0 && (
                                        <div style={{ fontWeight: '600', marginLeft: '2px' }}>+{item.newMessages}</div>
                                    )}
                                </div>
                            </TableItem>
                        )
                    }
                    return (
                        <TableItem>{value}</TableItem>
                    )
                }}
            </Table>
        </div>
    )
}
